<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Grosor del papel</span>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/paperWeight/80.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">80gr</span>
      <span class="section_info">El gramaje más común. o sea, un folio de toda la vida.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/paperWeight/90.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">90gr</span>
      <span class="section_info">Un pelín más grueso. Un pelín más grueso que un folio normal.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/paperWeight/100.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">100gr</span>
      <span class="section_info">Un poco más grueso aún. Con este seguro que no se transparentan los subrayados.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/paperWeight/120.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">120gr</span>
      <span class="section_info">Más grueso que el de 100gr, menos que el de 160gr.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/paperWeight/160.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">160gr</span>
      <span class="section_info"
        >Un papel ni muy fino ni muy grueso. Es duro y resistente pero sin pesar demasiado.</span
      >
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/paperWeight/200.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">200gr</span>
      <span class="section_info">Tipo cartulina fina. Es más ligera que una cartulina común.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/paperWeight/300.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">300gr</span>
      <span class="section_info"
        >Tipo cartulina del cole, ya sabes... de esas que se te olvidaban para el día de la exposición.</span
      >
    </div>
  </div>
</div>
